import { render, staticRenderFns } from "./BooleanRadioInput.vue?vue&type=template&id=6a7637cc"
import script from "./BooleanRadioInput.vue?vue&type=script&lang=ts"
export * from "./BooleanRadioInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports